export default __webpack_public_path__ + "static/media/trash.49ece382.svg";